import { fromString } from "css-color-converter"

export default function colorLuminance(color: string) {
  const c = fromString(color)
  if (c == null) return 0
  const hex = c.toHexString().substring(1) // strip #
  const rgb = parseInt(hex, 16) // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff // extract red
  const g = (rgb >> 8) & 0xff // extract green
  const b = (rgb >> 0) & 0xff // extract blue
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709
  return luminance
}
